import React, { useState, useRef, useEffect } from "react";
import axios from "axios";

export const Career = ({ career }) => {
  const [expandedJob, setExpandedJob] = useState(null);
  const [showPopup, setShowPopup] = useState(false);
  const [selectedJob, setSelectedJob] = useState("");

  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [file, setFile] = useState(null);
  const [errors, setErrors] = useState({});

  // NEW: success animation flag
  const [showSuccess, setShowSuccess] = useState(false);
  const successTimerRef = useRef(null);

  useEffect(() => {
    return () => {
      if (successTimerRef.current) clearTimeout(successTimerRef.current);
    };
  }, []);

  const toggleJob = (index) => {
    setExpandedJob(expandedJob === index ? null : index);
  };

  const validateForm = () => {
    const errors = {};
    if (!/^[a-zA-Z\s.]+$/.test(name)) {
      errors.name = "Name can only contain alphabets, spaces, and dots.";
    }
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      errors.email = "Invalid email address.";
    }
    if (!file) {
      errors.file = "Please upload your resume (PDF).";
    }
    return errors;
  };

  const submitapply = async (e) => {
    e.preventDefault();
    const validationErrors = validateForm();

    if (Object.keys(validationErrors).length === 0) {
      try {
        const formData = new FormData();
        formData.append("job", selectedJob);
        formData.append("name", name);
        formData.append("email", email);
        formData.append("file", file);
        await axios.post("/api/uploadfiles", formData, {
          headers: { "Content-Type": "multipart/form-data" },
        });

        // Close popup immediately & show CSS success animation
        setShowPopup(false);
        setShowSuccess(true);

        // Reset form fields & errors
        setName("");
        setEmail("");
        setFile(null);
        setSelectedJob("");
        setErrors({});

        // Auto-hide success animation after 3.2s
        if (successTimerRef.current) clearTimeout(successTimerRef.current);
        successTimerRef.current = setTimeout(() => setShowSuccess(false), 3200);
      } catch (err) {
        // If you still want an error toast, you can add your own CSS toast too
        alert("Server error: " + err.message);
      }
    } else {
      setErrors(validationErrors);
    }
  };

  return (
    <div className="career-page">
      <h2 className="career-heading">Current Openings</h2>

      {career && career.length > 0 ? (
        <div className="career-list">
          {career.map((item, i) => (
            <div key={i} className="career-item">
              <div className="career-header" onClick={() => toggleJob(i)}>
                <h3>{item.jobtitle}</h3>
                <span>{expandedJob === i ? "▲" : "▼"}</span>
              </div>

              <div
                className={`career-content ${expandedJob === i ? "show" : ""}`}
              >
                <p>
                  <b>Job Profile:</b> {item.jobprofile}
                </p>
                <div className="pre-tag">{item.jobdescription}</div>

                <div className="btn-wrapper">
                  <button
                    className="btn-apply"
                    onClick={() => {
                      setSelectedJob(item.jobtitle);
                      setShowPopup(true);
                    }}
                  >
                    Apply
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <h4 style={{ textAlign: "center", margin: "55px" }}>
          No job openings at the moment.
        </h4>
      )}

      {/* Apply Popup */}
      {showPopup && (
        <div className="popup" onClick={() => setShowPopup(false)}>
          <div className="popup-inner" onClick={(e) => e.stopPropagation()}>
            <button className="close-btn" onClick={() => setShowPopup(false)}>
              ✖
            </button>
            <h3 style={{ textAlign: "center" }}>
              Apply for <b>{selectedJob}</b>
            </h3>

            <form onSubmit={submitapply}>
              <div className="form-group">
                <label>Email</label>
                <input
                  type="email"
                  className={`form-control ${errors.email ? "is-invalid" : ""}`}
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
                {errors.email && (
                  <div className="invalid-feedback">{errors.email}</div>
                )}
              </div>

              <div className="form-group">
                <label>Name</label>
                <input
                  type="text"
                  className={`form-control ${errors.name ? "is-invalid" : ""}`}
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  required
                />
                {errors.name && (
                  <div className="invalid-feedback">{errors.name}</div>
                )}
              </div>

              <div className="form-group">
                <label>Upload Resume (PDF)</label>
                <input
                  type="file"
                  accept="application/pdf"
                  onChange={(e) => setFile(e.target.files?.[0] || null)}
                  className={errors.file ? "is-invalid" : ""}
                  required
                />
                {errors.file && (
                  <div className="invalid-feedback">{errors.file}</div>
                )}
              </div>

              <div className="btn-container">
                <button type="submit" className="btn-custom">
                  Submit Application
                </button>
                <button
                  type="button"
                  className="btn-back"
                  onClick={() => setShowPopup(false)}
                >
                  Cancel
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* CSS-only success animation */}
      {showSuccess && (
        <div className="success-overlay" role="status" aria-live="polite">
          <div className="success-stage">
            <div className="collector-box"></div>
            <div className="resume-sheet">
              <div className="resume-lines"></div>
              <div className="resume-lines short"></div>
              <div className="resume-lines"></div>
            </div>
            <div className="success-text">📥 Resume Collected!</div>
          </div>
        </div>
      )}
    </div>
  );
};
